
class Tabs {
	/** @var {HTMLDivElement} */
	container;
	
	/** @var {HTMLDivElement} */
	tablist;
	
	/** @var {HTMLButtonElement[]} */
	tabs;
	
	/** @var {HTMLDivElement[]} */
	panels;
	
	/** @var {int} */
	activeIndex = 0;

	/**
	 * Accessible Tabs widget.
	 *
	 * @param {HTMLElement} container The outer element that contains the tablist and panels.
	 */
	constructor( container ) {
		this.container = container;
		this.tablist = this.container.querySelector( '.tablist' );
		this.tabs = Array.from( this.tablist.querySelectorAll( '.tab' ) );
		this.panels = Array.from( this.container.querySelectorAll( '.panel' ) );

		// Register event listeners
		this.registerEventListeners();
	}

	/**
	 * Register click & keyboard handlers for every tab.
	 */
	registerEventListeners() {
		this.tabs.forEach( (tab, index) => {
			// Mouse click
			tab.addEventListener( 'click', () => this.activateTab( index ) );

			// Keyboard
			tab.addEventListener( 'keydown', event => this.handleKeyDown( event, index ) );
		} );
	}

	/**
	 * Activate a tab by index – updates ARIA, hidden attributes, tabindex, and focus.
	 * 
	 * @param {int} index
	 */
	activateTab( index ) {
		if( index === this.activeIndex ) {
			return;
		}

		// Deactivate previous tab / panel
		this.tabs[this.activeIndex].setAttribute('aria-selected', 'false');
		this.tabs[this.activeIndex].setAttribute('tabindex', '-1');
		this.tabs[this.activeIndex].classList.remove( 'active' );
		this.panels[this.activeIndex].hidden = true;
		this.panels[this.activeIndex].classList.remove( 'active' );

		// Activate new tab / panel
		this.tabs[index].setAttribute('aria-selected', 'true');
		this.tabs[index].setAttribute('tabindex', '0');
		this.tabs[index].focus();
		this.tabs[index].classList.add( 'active' );
		this.panels[index].hidden = false;
		this.panels[index].classList.add( 'active' );

		// Remember new active index
		this.activeIndex = index;
	}

	/**
	 * Keyboard navigation – arrow keys, Home/End, Enter/Space.
	 * 
	 * @param {KeyboardEvent} event
	 * @param {int} currentIndex
	 */
	handleKeyDown( event, currentIndex ) {
		const key = event.key;
		let newIndex = null;

		switch (key) {
			case 'ArrowRight':
			case 'ArrowDown':
				newIndex = (currentIndex + 1) % this.tabs.length;
				break;
			case 'ArrowLeft':
			case 'ArrowUp':
				newIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
				break;
			case 'Home':
				newIndex = 0;
				break;
			case 'End':
				newIndex = this.tabs.length - 1;
				break;
			case 'Enter':
			case ' ':
				// Activate the focused tab
				this.activateTab(currentIndex);
				event.preventDefault();
				return;
			default:
				return; // Do nothing for other keys
		}

		event.preventDefault();
		// Move focus to the new tab and activate it
		this.tabs[newIndex].focus();
		this.activateTab(newIndex);
	}
}

document.querySelectorAll( '.whippet-conditional-tabs' ).forEach( container => new Tabs( container ) );
